import React from "react";
import { RotatingText } from 'react-wavecoder-components';
import Text from "@mui/material/Typography";

interface AboutProps {
  className?: string;
}

const rotatingWords = ["SURF", "CODE"]; 

const About: React.FC<AboutProps> = ({ className }) => (
  <div className={className}>
    <Text color="text.primary" variant="h4">
      I <RotatingText words={rotatingWords} className="rotating-text" />
    </Text>
  </div>
);

export default About;